








































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_order_order } from '@/queries/__generated__/order';
import ShowPdfButton from '../../Shared/Buttons/ShowPdfButton.vue';
import { SmartQuery } from 'vue-apollo-decorator';
import { UNIT_INVOICE_SETTINGS } from '@/queries/CompanySetting';
import { GQL_unitInvoiceSetting, GQL_unitInvoiceSetting_currentUnit_unitSetting } from '@/queries/__generated__/unitInvoiceSetting';
import OrderMailButton from './OrderMailButton.vue';
import gql from 'graphql-tag';
import { orderMailLogsFragments } from '@/queries/orderMailLogsFragments';
import { ORDER_PDF } from './orderPdf';

const ORDER_CONFIRMATION_PDF = gql`
  query orderConfirmationPdf($id: ID!) {
    order(id: $id) { id pdf: orderConfirmationPdf { id url } }
  }
`;

const ORDER_OFFER_PDF = gql`
  query orderOfferPdf($id: ID!) {
    order(id: $id) { id pdf: offerPdf { id url } }
  }
`;

const ORDER_PACKING_SLIP_PDF = gql`
  query orderPackingSlipPdf($id: ID!) {
    order(id: $id) { id pdf: packingSlipPdf { id url } }
  }
`;

const ORDER_OFFER_MAIL_LOGS = gql`
  query orderOfferMailLogs($id: ID!) {
    order(id: $id) { id offerMailLogs { ...orderMailLogsFragments } }
  }
  ${orderMailLogsFragments}
`;

const ORDER_MAIL_LOGS = gql`
  query orderMailLogs($id: ID!) {
    order(id: $id) { id orderMailLogs { ...orderMailLogsFragments } }
  }
  ${orderMailLogsFragments}
`;

const ORDER_CONFIRMATION_MAIL_LOGS = gql`
  query orderConfirmationMailLogs($id: ID!) {
    order(id: $id) { id orderConfirmationMailLogs { ...orderMailLogsFragments } }
  }
  ${orderMailLogsFragments}
`;

const ORDER_PACKING_SLIP_MAIL_LOGS = gql`
  query orderPackingSlipMailLogs($id: ID!) {
    order(id: $id) { id packingSlipMailLogs { ...orderMailLogsFragments } }
  }
  ${orderMailLogsFragments}
`;

@Component({
  components: {
    ShowPdfButton,
    OrderMailButton,
  },
})
export default class OrderPdfSection extends Vue {
  @Prop(Object) public order!: GQL_order_order;
  @Prop(Boolean) public disabled = false;

  @SmartQuery<OrderPdfSection, GQL_unitInvoiceSetting>({
    query: () => UNIT_INVOICE_SETTINGS,
    update: (data) => data.currentUnit.unitSetting,
  }) public unitSetting!: GQL_unitInvoiceSetting_currentUnit_unitSetting;

  private ORDER_PDF = ORDER_PDF;
  private ORDER_CONFIRMATION_PDF = ORDER_CONFIRMATION_PDF;
  private ORDER_OFFER_PDF = ORDER_OFFER_PDF;
  private ORDER_PACKING_SLIP_PDF = ORDER_PACKING_SLIP_PDF;

  private ORDER_OFFER_MAIL_LOGS = ORDER_OFFER_MAIL_LOGS;
  private ORDER_MAIL_LOGS = ORDER_MAIL_LOGS;
  private ORDER_CONFIRMATION_MAIL_LOGS = ORDER_CONFIRMATION_MAIL_LOGS;
  private ORDER_PACKING_SLIP_MAIL_LOGS = ORDER_PACKING_SLIP_MAIL_LOGS;
}
